import React, { useEffect, useState } from 'react';
import './style/PremiumPaywall.css';
import TopNavbar from '../home/TopNavbar';
import { Link, useNavigate } from 'react-router-dom';
import { ChevronDown, ChevronUp } from 'lucide-react';

const faqData = [
    {
        question: "What study materials are included?",
        answer: "One subscription unlocks everything—including Mindmaps, Flashcards, Chapter-wise PYQs, Topper Notes, Mock Tests, and Question Banks."
    },
    {
        question: "How long is my subscription valid?",
        answer: "Your plan remains valid until the NEET exam date for the selected duration (1 Year = NEET 2027, 2 Years = NEET 2028, 3 Years = NEET 2029)."
    },
    {
        question: "What is the refund policy?",
        answer: "All purchases are final. Once a subscription is purchased and active, it is strictly non-refundable as full access to all digital study materials is granted immediately."
    },
    {
        question: "What if my payment is debited but I don't get premium access?",
        answer: "If money is deducted but premium content is not unlocked, any failed transaction is usually auto-refunded by Google Play / your bank within 3 to 5 business days. If you do not receive a refund after 5 days and your content is still locked, please reach out to us via our Contact section with your payment details for quick assistance."
    },
    {
        question: "Are there any hidden or recurring charges?",
        answer: "No, this is a simple one-time payment for the entire validity period. There are no recurring auto-debits."
    },
    {
        question: "How do I access locked content after payment?",
        answer: "Access is granted instantly! Once payment completes, all locked chapters across the app will unlock automatically."
    }
];

const PremiumPaywall = () => {
    const navigate = useNavigate();
    const isPayment = localStorage.getItem('userPayment');

    const [openFaqIndex, setOpenFaqIndex] = useState(null);

    useEffect(() => {
        if (isPayment) {
            navigate("/");
        }
    }, [isPayment, navigate]);

    const toggleFaq = (index) => {
        setOpenFaqIndex(openFaqIndex === index ? null : index);
    };

    return (
        <div className="paywall-container">
            <TopNavbar name="Premium content" />

            <div className="paywall-card">
                <div className="badge-container">
                    <span className="premium-badge">⚡ PREMIUM ACCESS</span>
                </div>

                <h1 className="paywall-title">Unlock All Study Material</h1>

                <p className="paywall-subtitle">
                    Supercharge your preparation. Get unlimited access to all of our premium resources designed to help you ace your exams.
                </p>

                <div className="single-sub-banner">
                    <span className="banner-icon">🎁</span>
                    <p><strong>One Single Subscription</strong> unlocks absolutely everything. No hidden charges. 📋 📅 👑 📕 🎴 🧠 ☀️ 🔁 🖼️ ❔</p>
                </div>

                <div className="subscription-box">
                    <div className="price-info">
                        <span className="membership-text">Get Membership Subscription</span>
                        <p className="sub-text">Instant access to all study materials instantly</p>
                    </div>

                    <Link to="/pay-razorpay" className="pay-button">
                        Subscribe & Unlock Now
                    </Link>
                </div>

                <p className="secure-text">🔒 Safe & Secure Payment Processing</p>

                {/* FAQ Section */}
                <div className="faq-section" style={{ marginTop: '30px', textAlign: 'left' }}>
                    <h3 style={{ 
                        fontSize: '18px', 
                        fontWeight: '700', 
                        color: '#1e293b', 
                        marginBottom: '16px',
                        textAlign: 'center' 
                    }}>
                        Frequently Asked Questions
                    </h3>

                    <div className="faq-list">
                        {faqData.map((faq, index) => {
                            const isOpen = openFaqIndex === index;
                            return (
                                <div 
                                    key={index} 
                                    style={{
                                        backgroundColor: '#ffffff',
                                        borderRadius: '12px',
                                        marginBottom: '10px',
                                        border: '1px solid #e2e8f0',
                                        overflow: 'hidden',
                                        boxShadow: '0 1px 3px rgba(0,0,0,0.05)'
                                    }}
                                >
                                    <button
                                        onClick={() => toggleFaq(index)}
                                        style={{
                                            width: '100%',
                                            padding: '14px 16px',
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'center',
                                            background: 'none',
                                            border: 'none',
                                            textAlign: 'left',
                                            fontWeight: '600',
                                            fontSize: '14px',
                                            color: '#334155',
                                            cursor: 'pointer'
                                        }}
                                    >
                                        <span>{faq.question}</span>
                                        {isOpen ? <ChevronUp size={18} color="#64748b" /> : <ChevronDown size={18} color="#64748b" />}
                                    </button>

                                    {isOpen && (
                                        <div style={{ 
                                            padding: '0 16px 14px 16px', 
                                            color: '#64748b', 
                                            fontSize: '13px', 
                                            lineHeight: '1.5',
                                            borderTop: '1px solid #f1f5f9',
                                            paddingTop: '10px'
                                        }}>
                                            {faq.answer}
                                        </div>
                                    )}
                                </div>
                            );
                        })}
                    </div>
                </div>

                <br /><br />
            </div>
        </div>
    );
};

export default PremiumPaywall;